module.exports = __webpack_public_path__ + "static/media/Gentona Book.ce6db9bd.otf";